import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {GetMemexChartResponse, UpdateMemexChartRequest} from './contracts/api'

export async function apiUpdateChart(body: UpdateMemexChartRequest): Promise<GetMemexChartResponse> {
  const apiMetadata = getApiMetadata('memex-chart-update-api-data')
  const {data} = await fetchJSON<UpdateMemexChartRequest, GetMemexChartResponse>(apiMetadata.url, {
    method: 'PUT',
    body,
    token: apiMetadata.token,
  })

  return data
}
